import React from 'react';

import Layout from '../components/Layout';

import Scroll from '../components/Scroll';

import doodleRead from '../assets/doodles/read.png';
import doodleHeart from '../assets/doodles/heart.png';
import doodleYoggie from '../assets/doodles/yoggie.png';
import doodleMeditate from '../assets/doodles/meditate.png';

import doodleRug from '../assets/images/illustrations/girl_phone_rug.png';
import doodleReading from '../assets/images/illustrations/ReadingSideDoodle2.png';
import doodleLoving from '../assets/images/illustrations/LovingDoodle.png';
import doodleBallet from '../assets/images/illustrations/BalletDoodle2.png';
import doodlePetting from '../assets/images/illustrations/PettingDoodle.png';
import doodleGroovy from '../assets/images/illustrations/GroovyDoodle.png';
import doodleSitting from '../assets/images/illustrations/SittingDoodle.png';
import doodleUnboxing from '../assets/images/illustrations/UnboxingDoodle.png';

import scrennshotMixed from '../assets/images/screenshots/screenshot_mixed_1.png';
import scrennshotMobile from '../assets/images/screenshots/screenshot_mobile_1.svg';

import pottedPlants from '../assets/images/illustrations/potted_plants.png';
import pottedPlantsFlip from '../assets/images/illustrations/potted_plants_flip.png';
import openhealingMapWorld from '../assets/images/illustrations/openhealing_map_world.jpg';
import config from '../../config';

const IndexPage = () => (
  <Layout>
      <main className="content">
        <section className="banner">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-12 text-center">
                <h1>Nourish your <br class="d-none d-sm-block" />emotional health</h1>
                <p>We're the #1 proven way to map your moods. <br class="d-none d-sm-block" />Optimize your wellness for a happier you.</p>
                <div className="cta">
                  <a href="#" class="btn btn-primary" target="_blank">Map your moods now <i className="fas fa-chevron-right" /></a>
                </div>
                <img className="rug" src={doodleRug} alt="Girl on rug with phone" />
                <img className="plants plant-left" src={pottedPlants} alt="Potted plants" />
                <img className="plants plant-right" src={pottedPlantsFlip} alt="Potted plants" />
              </div>
            </div>
          </div>
        </section>
        <section className="features text-center">
          <div className="container">
            <div className="row">
              <div className="col">
                <h2>Enjoy</h2>
                <h3>more optimal wellness</h3>
                <p>What are you experiencing in your emotional life? <br className="d-none d-sm-block" />Healify can help you get results in whatever matters most to you.</p>
              </div>
            </div>
            <div className="row">
              <div className="col-md-6">
                <img src={scrennshotMixed} />
              </div>
              <div className="col-md-6 text-start">
                <ul>
                  <li><h3>Relationships</h3></li>
                  <li><h3>Habits &amp; Addictions</h3></li>
                  <li><h3>Special Diagnoses</h3></li>
                  <li><h3>Depression</h3></li>
                  <li><h3>Anxiety</h3></li>
                  <li><h3>Anger</h3></li>
                </ul>
              </div>
            </div>
            <div className="row cta">
              <div className="col">
                <a href="#" className="btn" target="_blank">Get started for free <i className="fas fa-chevron-right" /></a>
              </div>
            </div>
          </div>
        </section>
        <section className="how-it-works text-center">
          <div className="container">
            <div className="row">
              <div className="col-md-12 text-center">
                <h2>Check in</h2>
                <h3>get support in a snap</h3>
                <p>Check in, map, and share your current feelings. <br class="d-none d-sm-block" />Get the care you deserve from your therapist or friends.</p>
              </div>
            </div>
            <div className="row p-3">
              <div className="col-md-4 text-center">
                <img src={doodleReading} alt="Reading Doodle" className="w-75" />
                <h4>Check in</h4>
                <p>Use Healify anytime to check in and make sense of your feelings.</p>
              </div>
              <div className="col-md-4 text-center">
                <img src={doodleLoving} alt="Loving Doodle" className="w-75" />
                <h4>Map your moods</h4>
                <p>See your mood score and report for over 20 common emotions.</p>
              </div>
              <div className="col-md-4 text-center">
                <img src={doodleBallet} alt="Ballet Doodle" className="w-75" />
                <h4>Get support</h4>
                <p>Share your results to get support from your therapist or friends.</p>
              </div>
            </div>
            <div className="row cta">
              <div className="col">
                <a href="#" className="btn" target="_blank">Get started for free <i className="fas fa-chevron-right" /></a>
              </div>
            </div>
          </div>
        </section>
       <section className="text-center">
          <div className="container">
            <div className="row">
              <div className="col">
                <h2>Discover</h2>
                <h3>stories and community</h3>
                <p>Discover other people's stories in our global healing map. <br class="d-none d-sm-block" />Share your own story and connect to a worldwide network of support.</p>
              </div>
            </div>
            <div className="row">
              <div className="col d-sm-none d-md-block">
                <img src={openhealingMapWorld} />
              </div>
            </div>
            <div className="row cta">
              <div className="col">
                <a href="#" className="btn" target="_blank">Get started for free <i className="fas fa-chevron-right" /></a>
              </div>
            </div>
          </div>
        </section>
        <section className="text-center">
          <div className="container">
            <div className="row">
              <div className="col">
                <h2>Science</h2>
                <h3>mood mapping works</h3>
                <p>Healify is based on decades of real-life clinical research. <br className="d-none d-sm-block" />Use the same powerful tools used by trained wellness professionals.</p>
              </div>
            </div>
            <div className="row circle-stats">
              <div className="col-md-4 text-center">
                <div className="circle ti-2">1M+</div>
                <p>We've mapped over a million mood data points, and growing daily.</p>
              </div>
              <div className="col-md-4 text-center">
                <div className="circle ti-2">95%</div>
                <p>We generate a 95%+ reliable map for your depression, anxiety, and more.</p>
              </div>
              <div className="col-md-4 text-center">
                <div className="circle ti-1">3.5x</div>
                <p>People who map moods as part of therapy enjoy 3.5x better results.</p>
              </div>
            </div>
            <div className="row cta">
              <div className="col">
                <a href="#" className="btn" target="_blank">Get started for free <i className="fas fa-chevron-right" /></a>
              </div>
            </div>
          </div>
        </section>
        <section className="testimonials text-center">
          <div className="container">
            <div className="row">
              <div className="col">
                <h2>Reviews</h2>
                <h3>from our customers</h3>
              </div>
            </div>
            <div className="row">
              <div className="col-md-10 offset-1 text-center">
                <div id="carouselExampleCaptions" className="carousel slide" data-bs-ride="carousel">
                  <ol className="carousel-indicators">
                    <li data-bs-target="#carouselExampleCaptions" data-bs-slide-to="0" className="active"></li>
                    <li data-bs-target="#carouselExampleCaptions" data-bs-slide-to="1"></li>
                    <li data-bs-target="#carouselExampleCaptions" data-bs-slide-to="2"></li>
                  </ol>
                  <div className="carousel-inner">
                    <div className="carousel-item active">
                      <div className="card">
                        <div className="card-header">
                          <i className="fab fa-envira"></i>
                          <h3>&#8220;Bravo!&#8221;</h3>
                          <div className="star-review">
                            <i className="fas fa-star"></i>
                            <i className="fas fa-star"></i>
                            <i className="fas fa-star"></i>
                            <i className="fas fa-star"></i>
                            <i className="fas fa-star"></i>
                          </div>
                          <p>&#8220;I must say that I am extremely impressed. Healify has the clarity and ease of a well-built interface, with the aesthetics of a pleasant walk in the woods. Bravo!&#8221;</p>
                          <p>P.H., Engineer<br />Oregon</p>
                        </div>
                      </div>
                    </div>
                    <div className="carousel-item">
                      <div className="card">
                        <div className="card-header">
                          <i className="fas fa-hand-holding-heart"></i>
                          <h3>&#8220;Using it daily&#8221;</h3>
                          <div className="star-review">
                            <i className="fas fa-star"></i>
                            <i className="fas fa-star"></i>
                            <i className="fas fa-star"></i>
                            <i className="fas fa-star"></i>
                            <i className="fas fa-star"></i>
                          </div>
                          <p>&#8220;I am using TEAM CBT almost on a daily basis. Healify saves me time and also provides me with easy access to Dr. Burns' mood surveys on my phone - this is great!&#8221;</p>
                          <p>S.Y., Professor<br />India</p>
                        </div>
                      </div>
                    </div>
                    <div className="carousel-item">
                      <div className="card">
                        <div className="card-header">
                          <i className="fas fa-universal-access"></i>
                          <h3>&#8220;User friendly&#8221;</h3>
                          <div className="star-review">
                            <i className="fas fa-star"></i>
                            <i className="fas fa-star"></i>
                            <i className="fas fa-star"></i>
                            <i className="fas fa-star"></i>
                            <i className="fas fa-star"></i>
                          </div>
                          <p>&#8220;Thank you for the kind and rapid responses you have given me! I am enjoying using the app in my sessions and find it very user friendly and easy to use.&#8221;</p>
                          <p>S.A., Digital Marketer<br />California</p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <a className="carousel-control-prev" href="#carouselExampleCaptions" role="button" data-bs-slide="prev">
                  <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                  <span className="sr-only">Previous</span>
                  </a>
                  <a class="carousel-control-next" href="#carouselExampleCaptions" role="button" data-bs-slide="next">
                    <span className="carousel-control-next-icon" aria-hidden="true"></span>
                    <span className="sr-only">Next</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="text-center">
          <div className="container">
            <div className="row">
              <div className="col">
                <h2>Get started</h2>
                <h3>map your moods right now</h3>
                <p>Map your depression, anxiety, anger, and positive feelings. <br className="d-none d-sm-block" />See your full mood report in less than 2 minutes. <br className="d-none d-sm-block" />Results are confidential and 100% free.</p>
              </div>
            </div>
            <div className="row cta">
              <div className="col">
                <a href="#" class="btn btn-primary" target="_blank">Map your moods now <i className="fas fa-chevron-right" /></a>
              </div>
            </div>
          </div>
        </section>
      </main>
  </Layout>
);

export default IndexPage;
